import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';

import { useMenuItems } from '../hooks/useMenuItems';
import { NewIndicators, SelectedIndicators } from './components/IndicatorsSection';

export const IndicatorsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();

  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_indicator_library,
    WidgetType.t_page,
  );

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.indicators'),
      }}
    >
      <Stack spacing={10}>
        <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
        <SelectedIndicators />
        <NewIndicators />
      </Stack>
    </SignedInPageLayout>
  );
};
